// extracted by mini-css-extract-plugin
export default {"hr":"hr___hr___d5fffd8e"};